const popup = document.querySelector(".popup");

if (popup) {
  const STORAGE_KEY = "maverick_popup_dismissed";
  const dismissDays = parseInt(popup.dataset.dismissDays || "7", 10);

  function isDismissed() {
    const val = localStorage.getItem(STORAGE_KEY);
    if (!val) return false;
    return Date.now() - parseInt(val, 10) < dismissDays * 86400000;
  }

  if (!isDismissed()) {
    setTimeout(() => popup.showModal(), 2000);
  }

  popup.querySelector(".popup-close")?.addEventListener("click", () => popup.close());

  // light-dismiss when clicking the backdrop
  popup.addEventListener("click", (e) => {
    if (e.target === popup) popup.close();
  });

  // persist dismissal on any close (button, Esc, or backdrop)
  popup.addEventListener("close", () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  });
}

//localStorage.removeItem('maverick_popup_dismissed');
